module.exports = "https://static.operabase.com/4fd4aa3a-01c0-4cdb-b191-e7bc5acefb1a/_next/static/images/bitmap-629d21b2a0fc6f254c69ea637037f10b.jpg";